import moment from 'moment';
import { getStatusForValue } from 'AppSrc/core/crq/crq-statuses';
import { SLA_FILTER_OPTIONS } from './crq-list-sla-filter';
import { SR_FILTER_OPTIONS } from './crq-list-circuit-check-filter';
import { store } from '../../store/store';

const crqStatusMatches = (crq, statuses) => {
  // if no statueses selected, dont filter
  if (!statuses || statuses.length === 0) {
    return true;
  }
  return statuses.some((statusValue) => {
    const status = getStatusForValue(statusValue);
    // crq.status could be either the text or value of the status
    // depending on whether the crq is mobile or fixed
    return [status.value, status.text].includes(crq.status);
    // return [status.value, status.text].includes(crq.coordinator_name);
  });
};

const crqSlaMatches = (crq, slas) => {
  // if no statueses selected, dont filter
  if (!slas || slas.length === 0) {
    return true;
  }
  return slas.some((sla) => {
    const slaOption = SLA_FILTER_OPTIONS.find((option) => option.id === sla);
    return slaOption && slaOption.values.includes(crq.timing);
  });
};

const crqStatusReasonMatches = (crq, statusReason) => {
  // if no statueses selected, dont filter
  if (!statusReason || statusReason.length === 0) {
    console.log('1188');
    return true;
  }
  return statusReason.some((reason) => {
    const statusReasonoption = SR_FILTER_OPTIONS.find((option) => option.id === reason);
    return statusReasonoption && statusReasonoption.values.includes(crq.status_reason);
  });
};


const crqStartDateMatches = (crq, startDate) => {
  if (!startDate) { return true; }
  // matches if they are the same day, month and year
  // see https://momentjs.com/docs/#/query/is-same/
  return moment(startDate).isSame(crq.start_date, 'day');
};

const crqEndDateMatches = (crq, endDate) => {
  if (!endDate) { return true; }
  // matches if they are the same day, month and year
  return moment(endDate).isSame(crq.end_date, 'day');
};

const crqRaisedDateMatches = (crq, raisedDate) => {
  if (!raisedDate) { return true; }
  // matches if they are the same day, month and year
  return moment(raisedDate).isSame(crq.submitted_date, 'day');
};

const checkMyCRQ = (crq, isMyCRQSelected) => {
  if (!isMyCRQSelected) {
    return true;
  }
  let user = store.getState().auth.user;
  // adding null check also, cause email value may not present in all response
  user = user.remedyIds.fixed ? user.remedyIds.fixed : user.remedyIds.mobile;
  // console.log('results', user);
  // user = 'spaltonm1';
  // console.log('crq', crq.coordinator_id);
  if (user) return user === (crq.coordinator_id || null);
  return true;
};

const checkFlight = (crq, isFlightSelected) => {
  if (!isFlightSelected) {
    return true;
  }
  // const now = moment('2021-04-12');
  const now = moment();
  // console.log('current date : ', now.format('YYYY-MM-DD'));
  // console.log('current start date : ', crq.start_date);
  // return moment(now.format('YYYY-MM-DD')).isBetween(moment(crq.startDate), moment(crq.end_date), undefined, []);
  return moment(now.format('YYYY-MM-DD')).isBetween(moment(crq.start_date), moment(crq.end_date), 'days', '[]');
};

// method to determine if a crq for the list table
// matches the provided filters
const crqMatchesFilters = (crq, filters) => {
  if (!filters) { return true; }
  const {
    startDate, endDate, raisedDate, statuses,
    slas, isMyCRQSelected, isFlightSelected, statusReason,
  } = filters;

  const statusMatches = crqStatusMatches(crq, statuses);
  const startDateMatches = crqStartDateMatches(crq, startDate);
  const endDateMatches = crqEndDateMatches(crq, endDate);
  const raisedDateMatches = crqRaisedDateMatches(crq, raisedDate);
  const slaMatches = crqSlaMatches(crq, slas);
  const mycrqs = checkMyCRQ(crq, isMyCRQSelected);
  const flightcrqs = checkFlight(crq, isFlightSelected);
  const statusReasonMatches = crqStatusReasonMatches(crq, statusReason);
  return statusMatches && startDateMatches && endDateMatches && raisedDateMatches && slaMatches && mycrqs && flightcrqs && statusReasonMatches;
};

export { crqMatchesFilters };
